import { JSX, useState } from "react";
import { useParams } from "react-router-dom";

import Grid from "@mui/material/Grid";

import OrganisationMenu from "./OrganisationMenu";
import { MenuOptionKey, MenuOptions } from "./OrganisationMenuOptions";
import OrganisationGeneralOverview from "./general/OrganisationGeneralOverview";
import OrganisationUsersOverview from "./user/OrganisationUsersOverview";

export default function EditOrganisationPage(): JSX.Element {
	const { id } = useParams();

	const organisationId = Number.parseInt(id ?? "0", 10);

	const [selectedOption, setSelectedOption] = useState<MenuOptionKey>(
		MenuOptions.GENERAL
	);

	return (
		<Grid container columnGap={2}>
			<Grid item>
				<OrganisationMenu
					selected={selectedOption}
					onSelect={setSelectedOption}
				/>
			</Grid>

			<Grid item flexGrow={1}>
				{selectedOption === MenuOptions.GENERAL && (
					<OrganisationGeneralOverview orgId={organisationId} />
				)}

				{selectedOption === MenuOptions.USERS && (
					<OrganisationUsersOverview orgId={organisationId} />
				)}
			</Grid>
		</Grid>
	);
}
